import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=1c94c11d&scoped=true&"
import script from "./Statements.vue?vue&type=script&lang=js&"
export * from "./Statements.vue?vue&type=script&lang=js&"
import style0 from "./Statements.vue?vue&type=style&index=0&id=1c94c11d&prod&lang=scss&"
import style1 from "./Statements.vue?vue&type=style&index=1&id=1c94c11d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94c11d",
  null
  
)

export default component.exports